import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { FormattedMessage, useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
import { styled } from "@material-ui/styles";
// component, hooks
import Typography from "@mui/material/Typography";
import useLocaleRoute from "../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../hooks/useModulePublic";
// store
import { StoreContext } from "../../../../store/StoreProvider";
import Act from "../../../../store/actions";
// config,utils
import {
  ROUTE_PATH,
  ROUTE_NAME,
  MODULE_ID,
} from "../../../../config/CONSTANTS";
import urls from "../../../../api/project/ApiUrls";
import featureDisplay from "../../../../common/utils/featureDisplay";

// style
const StyledBox = styled(
  Box,
  {}
)(({ theme }) => ({
  "&:hover": {
    cursor: "pointer",
  },
}));

const StyledLinkDark = styled(
  "span",
  {}
)(({ theme }) => ({
  color: "#3bbff0",
  cursor: "pointer",
  textDecoration: "underline",
}));

const StyledLinkBlue = styled(
  "span",
  {}
)(({ theme }) => ({
  color: "#3bbff0",
  cursor: "pointer",
  textDecoration: "underline",
}));

const disabledLinkSx = {
  color: "#000",
  cursor: "inherit",
  textDecoration: "none",
};

const LoginBottom = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // local state
  const [test, setTest] = useState(0);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  const disabledPrivacyLink = !handlePublic(MODULE_ID.privacyPageLink);
  const disabledServiceLink = !handlePublic(MODULE_ID.servicePageLink);

  return (
    <Box>
      <Typography textAlign="center">
        <FormattedMessage
          id="login.agree.privacy"
          defaultMessage="繼續使用代表您同意 社會網絡分析平台 的"
        />
        <StyledLinkBlue
          onClick={() => {
            if (!disabledServiceLink) {
              navigate(handleLocaleRoute(ROUTE_PATH.ServicePage));
            }
          }}
          style={{
            ...(disabledServiceLink ? disabledLinkSx : {}),
          }}
        >
          {intl.formatMessage({
            id: "login.terms.of.service",
            defaultMessage: "《服務條款》",
          })}
        </StyledLinkBlue>
        <span>
          {intl.formatMessage({
            id: "login.signin.and",
            defaultMessage: "和",
          })}
        </span>
        <StyledLinkBlue
          onClick={() => {
            if (!disabledPrivacyLink) {
              navigate(handleLocaleRoute(ROUTE_PATH.PrivacyPage));
            }
          }}
          style={{
            ...(disabledPrivacyLink ? disabledLinkSx : {}),
          }}
        >
          {intl.formatMessage({
            id: "login.privacy.policy",
            defaultMessage: "《隱私權政策》",
          })}
        </StyledLinkBlue>
      </Typography>
    </Box>
  );
};

LoginBottom.propTypes = {};

LoginBottom.defaultProps = {};

export default LoginBottom;
